import { useEffect, useState } from 'react'
import { Alert, Button, Container, Paper, TextField, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import sessionStore from '../stores/sessionStore'
import { authErrorMessage } from '../auth/authErrors'

export default function ResetPassword() {
	const navigate = useNavigate()
	const [token, setToken] = useState(() => new URLSearchParams(window.location.search).get('token') || '')
	const [password, setPassword] = useState('')
	const [confirm, setConfirm] = useState('')
	const [error, setError] = useState('')
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		window.history.replaceState({}, '', '/reset-password')
	}, [])

	const submit = async event => {
		event.preventDefault(); setError('')
		if (!token) return setError('Ссылка сброса пароля недействительна.')
		if (password !== confirm) return setError('Пароли не совпадают.')
		if (password.length < 8 || password.length > 128) return setError('Пароль должен содержать от 8 до 128 символов.')
		setLoading(true)
		try {
			await sessionStore.resetPassword(token, password)
			setToken(''); setPassword(''); setConfirm('')
			navigate('/login', { replace: true, state: { passwordReset: true } })
		} catch (reason) { setError(authErrorMessage(reason)) }
		finally { setLoading(false) }
	}

	return <Container maxWidth='xs'><Paper sx={{ p: 3, mt: 5 }}>
		<Typography variant='h5'>Новый пароль</Typography>
		{error && <Alert severity='error' sx={{ my: 2 }}>{error}</Alert>}
		<form onSubmit={submit}>
			<TextField fullWidth type='password' label='Новый пароль' value={password} onChange={e => setPassword(e.target.value)} sx={{ my: 1 }} />
			<TextField fullWidth type='password' label='Повторите пароль' value={confirm} onChange={e => setConfirm(e.target.value)} sx={{ my: 1 }} />
			<Button fullWidth type='submit' variant='contained' disabled={loading}>Сохранить пароль</Button>
		</form>
	</Paper></Container>
}
